import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../config/api';
import './ChangeLog.css';

const ChangeLog = ({ entityType, entityId }) => {
  const { t } = useTranslation();
  const [changeLogs, setChangeLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showLog, setShowLog] = useState(false);

  useEffect(() => {
    if (showLog && entityId) {
      fetchChangeLogs();
    }
  }, [showLog, entityId]);

  const fetchChangeLogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/admin/changelog/${entityType}/${entityId}`);
      setChangeLogs(response.data);
    } catch (error) {
      console.error('Error fetching change logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatValue = (value) => {
    if (value === null || value === undefined) return 'N/A';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    return String(value);
  };

  if (!showLog) {
    return (
      <button 
        className="btn-view-changelog" 
        onClick={() => setShowLog(true)}
      >
        {t('admin.viewChangeLog')}
      </button>
    );
  }

  return (
    <div className="changelog-container">
      <div className="changelog-header">
        <h3>{t('admin.changeLog')}</h3>
        <button className="close-changelog" onClick={() => setShowLog(false)}>×</button>
      </div>
      {loading ? (
        <div className="changelog-loading">{t('admin.loading')}</div>
      ) : changeLogs.length === 0 ? (
        <div className="changelog-empty">{t('admin.noChanges')}</div>
      ) : (
        <div className="changelog-list">
          {changeLogs.map((log, index) => (
            <div key={index} className="changelog-item">
              <div className="changelog-meta">
                <span className="changelog-date">{formatDate(log.createdAt)}</span>
                <span className="changelog-user">
                  {log.changedByName || (log.changedBy ? `${log.changedBy.firstName} ${log.changedBy.lastName}` : 'Unknown')}
                  {log.changedByRole && ` (${log.changedByRole})`}
                </span>
              </div>
              <div className="changelog-action">
                <strong>{t(`admin.${log.action}`)}</strong>
                {log.description && <span className="changelog-description"> - {log.description}</span>}
              </div>
              {log.field && (
                <div className="changelog-details">
                  <div className="changelog-field">
                    <strong>{t('admin.field')}:</strong> {log.field}
                  </div>
                  {log.oldValue !== null && log.oldValue !== undefined && (
                    <div className="changelog-value old">
                      <strong>{t('admin.oldValue')}:</strong> {formatValue(log.oldValue)}
                    </div>
                  )}
                  {log.newValue !== null && log.newValue !== undefined && (
                    <div className="changelog-value new">
                      <strong>{t('admin.newValue')}:</strong> {formatValue(log.newValue)}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChangeLog;
